import { create } from 'zustand'
import type { MeResponse } from '@ledokol/contracts'
import { fetchMe } from '../../shared/api/auth'

interface AuthState {
  // Блок Б: MeResponse = UserDto + permissions + accessible_department_ids.
  // permissions нужны фронту для гейтинга (слой 6 — пункт «Роли и доступы»).
  user: MeResponse | null
  status: 'idle' | 'loading' | 'authenticated' | 'unauthenticated'
  setUser: (u: MeResponse | null) => void
  setStatus: (s: AuthState['status']) => void
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  status: 'idle',
  setUser: (user) => set({ user, status: user ? 'authenticated' : 'unauthenticated' }),
  setStatus: (status) => set({ status }),
}))

/**
 * Перечитать GET /me и положить в стор. Зовётся после серверных мутаций
 * полей user, влияющих на shell/баннер/навигацию (tg-привязка, role, dept).
 *
 * До этой функции глобальный user в `useAuthStore` инициализировался **один
 * раз** в `auth-gate.tsx` при старте SPA — любое изменение профиля на сервере
 * приводило к рассогласованию UI до перезагрузки страницы. Конкретный
 * симптом, починенный 2026-06-16: shell-баннер «Привязать Telegram» висел
 * после успешного двух-шагового confirm на /me/telegram (баннер смотрит
 * stale `user.tg_linked_at`, а локальный state страницы уже обновился).
 *
 * Общая и tg-нейтральная by design: будущие вызовы (например, edit самого
 * себя через admin-users — backlog) звать одной строкой `await refreshMe()`.
 *
 * Ошибки молча гасим: на 401 рефреш-токен и redirect делает client/AuthGate;
 * на сетевую ошибку наказывать пользователя toast'ом не за что — он только
 * что успешно завершил mutation и видит её результат локально.
 */
export async function refreshMe(): Promise<void> {
  try {
    const me = await fetchMe()
    useAuthStore.getState().setUser(me)
  } catch {
    // см. JSDoc: молчим намеренно
  }
}
